import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {func, object, string} from 'prop-types';
import React, {useCallback, useState} from 'react';
import {useTopics} from '../../client.js';
import {cmdOrCtrl} from '../../utils.js';

function Topic({sx, onChange, value}) {
  const {data: availableTopics} = useTopics();
  const topics = (value || '')
    .split(',')
    .map(v => v.trim())
    .filter(Boolean);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = !!anchorEl;

  const onButtonClick = useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const onMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const onMenuItemClick = useCallback(
    (event, newValue) => {
      let newTopic = newValue;
      if (newValue && cmdOrCtrl(event)) {
        const existingTopics = new Set(topics);
        existingTopics.add(newValue);
        newTopic = Array.from(existingTopics).join(',');
      }
      onChange(newTopic);
      setAnchorEl(null);
    },
    [onChange, topics],
  );

  const label = topics.length > 0 ? topics.join(', ') : 'All Topics';
  const color = topics.length > 0 ? 'primary' : 'secondary';

  return (
    <Box sx={sx}>
      <Button
        onClick={onButtonClick}
        variant="outlined"
        size="small"
        color={color}
        endIcon={<ArrowDropDownIcon />}
      >
        {label}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={onMenuClose}>
        <MenuItem
          onClick={event => onMenuItemClick(event, '')}
          dense
          sx={{textTransform: 'uppercase'}}
        >
          All Topics
        </MenuItem>
        {availableTopics &&
          availableTopics.map(t => (
            <MenuItem
              key={t}
              onClick={event => onMenuItemClick(event, t)}
              dense
              sx={{textTransform: 'uppercase'}}
            >
              {t}
              <ListItemIcon sx={{marginLeft: 2}}>
                {topics.includes(t) ? <CheckIcon fontSize="small" /> : null}
              </ListItemIcon>
            </MenuItem>
          ))}
      </Menu>
    </Box>
  );
}

Topic.propTypes = {
  sx: object,
  onChange: func.isRequired,
  value: string,
};

export default Topic;
